import { TitleDescAndSideItemsProps } from "@/app/types/neighborhoodsPageTypes";
import Image from "next/image";
import { optimizeImageUrl } from "@/app/utils/optimizeImageUrl";

const TitleDescAndSideItems: React.FC<TitleDescAndSideItemsProps> = ({
	title,
	description,
	items,
	CustomClass,
	insideAmenitiesDetailsPage,
	optimizedImage,
}) => {

	return (
		<div
			className={`flex flex-col lg:flex-row items-start justify-between gap-12 lg:gap-8 py-[2.75rem] lg:py-[6.25rem]  px ${CustomClass} bg-white`}
		>
			{/* Left Section */}
			<div className={`flex flex-col w-full lg:w-1/2 ${insideAmenitiesDetailsPage ? "lg:pe-[10%]" : "lg:pe-[15%]"}`}>
				<h2 className="text-h4 w-[22rem] mt-[-1.6rem] small-mobile:w-[21rem]">{title}</h2>
				<p className="mt-4 font-national text-bodyM opacity-60 whitespace-pre-line">
					{description}
				</p>
			</div>

			{/* Right Section */}
			<div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-y-[4rem] w-full lg:w-1/2">
				{items?.map((item, index) => (
					item.sub_title.en && item.sub_title.en !== "-" && <div
						key={item.id}
						className={`flex flex-col items-center relative ${
							item?.logo && "ps-12 lg:ps-0"
						}`}
					>
						<p className="text-bodyS uppercase text-oBlue-300">
							{item.title.en}
						</p>

						{item.title.en.toLowerCase() === "sqm" ? (
							// <SuperscriptText
							// text={item.sub_title.en}
							// mainTextFontClass="text-h4"
							// supTextFontClass="text-h6"
							// />
							<p className="text-h4">
								{`${item.sub_title.en} M`}
								<sup>2</sup>
							</p>
						) : (
							<p className="text-h4">{item.sub_title.en}</p>
						)}

						{item?.logo && (
							<div className="absolute start-0 lg:-start-12 bottom-5 w-[2rem] h-[2.125rem]">
								<Image
									fill
									alt={item.iconImgAlt || "Live Close Item Icon"}
									src={
										optimizedImage
											? optimizeImageUrl(
													`${process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL}${item?.logo?.media_name}`,
													{ width: 64, quality: 80 }
												)
											: `${process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL}${item?.logo?.media_name}`
									}
									loading="lazy"
									quality={75}
								/>
							</div>
						)}
					</div>
				))}
			</div>
		</div>
	);
};

export default TitleDescAndSideItems;
